import { useReactQuery } from './index'

/**
 * Custom hook that conditionally uses useReactQuery based on whether content is provided
 * @param {Object} queryConfig - The query configuration object
 * @param {boolean} hasContent - Whether content is already available
 * @param {any} fallbackData - The fallback data to use when hasContent is true
 * @returns {Object} Query result with data, loading states, etc.
 */
export const useConditionalQuery = (queryConfig, props) => {
  const hasContent = !!props?.serverData || null
  const propsData = props.serverData // USED IN "prismData"
  
  // Disable the query if content is already available
  const conditionalConfig = {
    ...queryConfig,
    queryDetails: {
      ...queryConfig.queryDetails,
      enabled: !hasContent && (queryConfig.queryDetails?.enabled !== false)
    }
  }

  const queryResult = useReactQuery(conditionalConfig)

  // Return appropriate values based on whether content is available
  if (hasContent) {
    const cachedData = {
      ...queryResult,
      data: propsData,
      isLoading: false,
      isSuccess: true,
      isError: false,
      error: null,
    }
    return cachedData
  }

  return queryResult
}